import { globalTheme } from '@pulsepointinc/bi-components';
import styled from 'styled-components';

export const Container = styled.div<{ dense?: boolean }>`
  padding: 20px 48px;

  ${({ dense }) => (dense ? 'padding-bottom: 0;' : '')}

  .category-switch {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .divider {
    margin: 24px 0;
    background: ${globalTheme.colors.outlineLight};
  }
`;

export const SwitchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
